import { format } from 'date-fns';
import { IScript } from './orders';

export const unmountScript = ({
  hasScript,
  script,
  recordingType,
  recordingDate,
  recordingTime,
  recordingPlace,
}: {
  hasScript: boolean;
  script: IScript | null;
  recordingType: string;
  recordingDate: string;
  recordingTime: string;
  recordingPlace: string;
}) => {
  const formatTime = (date: string, time: string) => {
    const someDate = format(new Date(date), 'yyyy-MM-dd');
    const someTime = format(new Date(time), 'HH:mm');

    return new Date(someDate + 'T' + someTime).toISOString();
  };

  const recordingDateWithoutScript = !hasScript ? formatTime(recordingDate, recordingTime) : '';

  return {
    hasScript,
    ...(hasScript && {
      script: script?.numero,
      scenesCount: script?.scenesCount,
    }),
    recordingType: hasScript ? script?.tipoRoteiro?.toString() : recordingType,
    startRecordingDate: hasScript
      ? new Date(script?.dataHoraInicioRoteiro as string).toISOString()
      : recordingDateWithoutScript,
    startRecordingTime: hasScript
      ? new Date(script?.dataHoraInicioRoteiro as string).toISOString()
      : recordingDateWithoutScript,
    endingRecordingDate: hasScript ? script?.dataHoraFimRoteiro : recordingDateWithoutScript,
    endingRecordingTime: hasScript ? script?.dataHoraFimRoteiro : recordingDateWithoutScript,
    recordingPlace: hasScript ? script?.localGravacaoRoteiro?.nome : recordingPlace,
  };
};

export const mountScript = ({
  hasScript,
  scenesCount,
  recordingType,
  recordingPlace,
  startRecordingDate,
  endingRecordingDate,
  startRecordingTime,
  script,
}: {
  scenesCount: number;
  hasScript: boolean;
  recordingType: string;
  recordingPlace: string;
  startRecordingDate: string;
  endingRecordingDate: string;
  startRecordingTime: string;
  script: string;
}) => ({
  hasScript: `${hasScript}`,
  ...(hasScript && {
    script: {
      scenesCount,
      numero: script,
      tipoRoteiro: recordingType,
      dataRoteiro: startRecordingDate,
      dataHoraInicioRoteiro: startRecordingTime,
      localGravacaoRoteiro: { nome: recordingPlace },
      dataHoraFimRoteiro: endingRecordingDate,
    },
  }),
  ...(!hasScript && {
    recordingTime: startRecordingTime,
    recordingDate: startRecordingDate,
    recordingType,
    recordingPlace,
  }),
  localGravacaoRoteiro: recordingPlace,
});
